import React, { Component } from 'react';

import css from './address.css';

// Material UI Library
import TextField from 'material-ui/TextField';

class Address extends Component {

  constructor(props) {
    super(props);
    this.formAttributes = {
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip: '',
    };
  }

  componentWillUnmount() {
    this.formAttributes = null;
  }

  handleInputChange = (property, e) => {
    // Update internal form attributes
    this.formAttributes[property] = e.target.value;

    // Update parent form attributes
    this.props.updateForm(this.formAttributes);
  };

  render() {
    const styles = {
      textField: {
        width: 'auto',
      },
    };

    return (
      <div className={css.root}>
        <TextField
          floatingLabelText="Street Address"
          className={css.textField}
          style={styles.textField}
          onChange={this.handleInputChange.bind(this, 'street1')}
        />
        <TextField
          floatingLabelText="Street Address 2"
          className={css.textField}
          style={styles.textField}
          onChange={this.handleInputChange.bind(this, 'street2')}
        />
        <TextField
          floatingLabelText="City"
          className={css.textField}
          style={styles.textField}
          onChange={this.handleInputChange.bind(this, 'city')}
        />
        <TextField
          floatingLabelText="State"
          className={css.textField}
          style={styles.textField}
          onChange={this.handleInputChange.bind(this, 'state')}
        />
        <TextField
          floatingLabelText="Zip"
          className={css.textField}
          style={styles.textField}
          onChange={this.handleInputChange.bind(this, 'zip')}
        />
      </div>
    );
  }
}

export default Address;



/** WEBPACK FOOTER **
 ** ./components/forms/Address.js
 **/